module.exports = __webpack_public_path__ + "six.87e2c8d04fd8a3fa863affc060e123c7.png";